import { render } from "./LiquidityPage.vue?vue&type=template&id=225156df"
import script from "./LiquidityPage.vue?vue&type=script&lang=js"
export * from "./LiquidityPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__